import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import logo from "../assets2/1.png";
import Modal from "react-modal";
import SignInAndLaunchStudio from "./SignInAndLaunchStudio";
import { Amplify, Auth } from "aws-amplify";
import { RxCross1 } from "react-icons/rx";
import toast from "react-hot-toast";
import { Route, Routes, useNavigate } from "react-router-dom";
import './styles.css';

Modal.setAppElement("#root");
const Navbar = ({ isUserLoggedIn, setIsUserLoggedIn }) => {
  const [showModalForSignIn, setShowModalForSignIn] = useState(false);
  const [showModalAccount, setShowModalAccount] = useState(false); // user can change pwd when logged in
  const [currentPwd, setCurrentPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmNewPwd, setConfirmNewPwd] = useState("");
  const [errorx, setErrorX] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const state = useSelector((state) => state.handleCart);
  const navigate = useNavigate();

  useEffect(() => {
    const getUserEmail = async () => {
      try {
        let test = await Auth.currentAuthenticatedUser();
        setUserEmail(test.attributes.email);
      } catch (err) {
        // alert(" ======== 1x =========")
        // setErrorX(true);
        setUserEmail("");
      }
    };

    getUserEmail();
  });

  const changeUserPassword = async () => {
    if (!currentPwd || !newPwd || currentPwd === "" || newPwd === "") {
      setErrorX(true);
      return;
    }

    if (newPwd !== confirmNewPwd) {
      setErrorX(true);
      return;
    }

    try {
      let user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(user, currentPwd, newPwd);
      setCurrentPwd("");
      setNewPwd("");
      setConfirmNewPwd("");
      setErrorX(false);
      setShowModalAccount(false);
      toast.success("Password change successful");
    } catch (err) {
      setCurrentPwd("");
      setNewPwd("");
      setConfirmNewPwd("");
      // console.log(err);
      setErrorX(true);
    }
  };

  const showJobs = async () => {
    if (isUserLoggedIn === false) {
      toast((t) => (
        <div
          style={{
            margin: 0,
            backgroundColor: "#3C3D37",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: 10,
          }}
        >
          <h4 style={{ padding: 2, color: "white" }}>Please login first</h4>
          <h4 style={{ padding: 2, color: "white" }}>पहले लॉग-इन करें</h4>
          <button onClick={() => toast.dismiss(t.id)}>OK</button>
        </div>
      ));

      return
    }

    navigate("/jobs")
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light py-3 ">
      <div className="container">
        <img
          //   className="card-img img-fluid"
          src={logo}
          alt="Logo"
          height={40}
        />
        <NavLink className="navbar-brand fw-bold fs-6 px-2" to="/">
          {" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ZENFURA FASHION
        </NavLink>
        <button
          className="navbar-toggler mx-2"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent"  >
          <ul className="navbar-nav m-auto my-2 text-center" >
            <li className="nav-item" >
              <NavLink className="nav-link" to="/">
                HOME{" "}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/products">
                SHOP-NOW
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/about">
                ABOUT
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink className="nav-link" to="/contact">
                Contact
              </NavLink>
            </li>
            <li className="nav-item">
              <p className="nav-link" style={{ margin: 0 }} onClick={showJobs}>
                Jobs
              </p>
            </li> */}
            {/* {isUserLoggedIn === true ? (
              <li className="nav-item">
                <p
                  className="nav-link"
                  style={{ margin: 0 }}
                  onClick={() => setShowModalAccount(true)}
                >
                  Settings
                </p>
              </li>
            ) : (
              <></>
            )} */}
          </ul>
          {/* <div className="buttons text-center">
            
            {isUserLoggedIn === true ? (
              <NavLink
                onClick={async () => {
                  await Auth.signOut();
                  setIsUserLoggedIn(false);
                }}
                className="btn btn-outline-light m-2"
              >
                <i className="fa fa-sign-out-alt mr-1"></i> Logout
              </NavLink>
            ) : (
              <NavLink
                onClick={() => setShowModalForSignIn(true)}
                className="btn btn-outline-dark m-2"
              >
                <i className="fa fa-sign-in-alt mr-1"></i> Login
              </NavLink>
            )}
            <NavLink to="/register" className="btn btn-outline-dark m-2">
              <i className="fa fa-user-plus mr-1"></i> Register
            </NavLink>
            <NavLink to="/cart" className="btn btn-outline-dark m-2">
              <i className="fa fa-cart-shopping mr-1"></i> Cart ({state.length}){" "}
            </NavLink>
          </div> */}
        </div>
      </div>
      {/** Modal pop up for sign in sign up etc. */}
      <Modal
        isOpen={showModalForSignIn}
        // onRequestClose={() => setShowModal(false)}
        style={{
          overlay: {
            zIndex: 99020,
            width: "90%",
            height: "90%",
            marginLeft: "5%",
            marginTop: "2%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(55, 55, 55, 1)",
            borderRadius: 44
          },
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            borderRadius: 25
          },
        }}
      >
        <SignInAndLaunchStudio
          setShowModalForSignIn={setShowModalForSignIn}
          setIsUserLoggedIn={setIsUserLoggedIn}
        />
      </Modal>
      {/** Below Modal is for Account ( or profile ) - user can change pwd when logged in  */}
      <Modal
        isOpen={showModalAccount}
        onRequestClose={() => setShowModalAccount(false)}
        style={{
          overlay: {
            zIndex: 99020,
            width: "90%",
            height: "90%",
            marginLeft: "5%",
            marginTop: "2%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(44, 44, 44, 1)",
          },
          content: {
            margin: "0px",
            padding: "5px",
            backgroundColor: "rgba(255, 255, 255, 1)",
          },
        }}
      >
        <div
          style={{
            height: "10%",
            display: "flex",
            // backgroundColor: "green",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4>Check info or change password.</h4>
          <RxCross1
            onClick={() => {
              setShowModalAccount(false);
              setErrorX(false);
              setCurrentPwd("");
              setNewPwd("");
              setConfirmNewPwd("");
            }}
            size={"30px"}
            color={"#243346"}
          />
        </div>
        <h5 style={{ margin: "0px" }}>E-mail (Username): {userEmail}</h5>
        <div
          style={{
            width: "40%",
            height: "10%",
            // backgroundColor: "#392E2E",
            backgroundColor: "#243346",
            marginTop: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 5,
            borderColor: "white",
          }}
          onClick={() => {
            // verifyEmailCode();
            // setErrorx("");
            // logOutFromStudio();
            Auth.signOut();
            setShowModalAccount(false);
            setIsUserLoggedIn(false);
          }}
        >
          <p style={{ color: "white", fontWeight: "bold", margin: 0 }}>
            LOGOUT OF THE APP{" "}
          </p>
        </div>
        <h4 style={{ marginTop: "10px" }}>
          --------------------------------------------- OR
          ---------------------------------------------
        </h4>
        <h4 style={{ margin: "0px" }}>
          Change password ? Enter current and new password below:{" "}
        </h4>
        <input
          style={{ width: "40%", marginBottom: "5px" }}
          placeholder="Current password"
          value={currentPwd}
          onChange={(e) => setCurrentPwd(e.target.value)}
        />{" "}
        <br />
        <p style={{ margin: "0px", padding: "0px" }}>
          New password must be 6 characters or more
        </p>
        <input
          style={{ width: "40%", marginBottom: "5px" }}
          placeholder="New password"
          value={newPwd}
          onChange={(e) => setNewPwd(e.target.value)}
        />{" "}
        <br />
        <input
          style={{ width: "40%" }}
          placeholder="Confirm new password"
          value={confirmNewPwd}
          onChange={(e) => setConfirmNewPwd(e.target.value)}
        />
        <div
          style={{
            width: "40%",
            height: "10%",
            // backgroundColor: "#392E2E",
            backgroundColor: "#243346",
            marginTop: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 5,
            borderColor: "white",
          }}
          onClick={() => {
            // verifyEmailCode();
            // setErrorx("");
            changeUserPassword();
          }}
        >
          <p style={{ color: "white", fontWeight: "bold", margin: 0 }}>
            CHANGE PASSWORD{" "}
          </p>
        </div>
        {errorx === true ? (
          <h3 style={{ color: "darkred" }}>Some error occured</h3>
        ) : (
          <></>
        )}
      </Modal>
    </nav>
  );
};

export default Navbar;
